// extracted by mini-css-extract-plugin
export default {"root":"TopicTypeModal_root__qHdKk","btnAdd":"TopicTypeModal_btnAdd__bPS4X"};